import React from 'react';
import { motion } from 'framer-motion';
import { FileClockIcon, FileSearchIcon, LightbulbIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [['BONO 1', 'La Gran Cronología Maya', 'Una línea temporal para comprender los hitos esenciales de esta civilización.', FileClockIcon], ['BONO 2', '101 Curiosidades Fascinantes', 'Detalles sorprendentes para enriquecer cada lectura.', LightbulbIcon], ['BONO 3', 'Expedientes Secretos Mayas', 'Casos, hallazgos y enigmas para seguir explorando.', FileSearchIcon]];
  return <section className="px-5 py-24 md:py-32" data-id="element-30">
      <div className="mx-auto max-w-7xl" data-id="element-31">
        <div className="mb-14 text-center" data-id="element-32">
          <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-33">
            Incluidos con tu acceso
          </p>
          <h2 className="mt-3 text-4xl font-semibold text-stone-light md:text-6xl" data-id="element-34">
            Además recibirás estos bonos exclusivos
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3" data-id="element-35">
          {bonuses.map(([number, title, text, Icon], index) => <motion.article key={number as string} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="rounded-xl border border-[#625237] bg-[#171B16] p-7" data-id="element-36">
              <Icon className="mb-8 h-6 w-6 text-gold-light" data-id="element-37" />
              <p className="text-xs font-bold tracking-[.16em] text-gold" data-id="element-38">
                {number}
              </p>
              <h3 className="mt-3 text-2xl font-semibold text-stone-light" data-id="element-39">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-stone" data-id="element-40">{text}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}